import { Flex, Tag } from 'antd';
import { useCallback } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const BirthdaySelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeBirthdayPeriod } = useNewClientsListContext();

  const { birthdayPeriod } = filtersMap.get(id)!;

  const onDelete = useCallback(
    (index: number) => {
      if (birthdayPeriod === null) {
        return;
      }
      const [start, end] = birthdayPeriod;
      if (index === 0) {
        onChangeBirthdayPeriod([null, end], id);
        return;
      } else {
        onChangeBirthdayPeriod([start, null], id);
        return;
      }
    },
    [birthdayPeriod, onChangeBirthdayPeriod, id]
  );

  if (birthdayPeriod === null) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {birthdayPeriod?.map((date, index) => {
        if (!date) {
          return null;
        }

        const formatedDate = date.format('DD.MM');

        const label = index === 0 ? `с ${formatedDate}` : `по ${formatedDate}`;
        return (
          <Tag
            key={label}
            className={`${PF}__tag`}
            closable
            onClose={() => onDelete(index)}
          >
            {label}
          </Tag>
        );
      })}
    </Flex>
  );
};
